import { History } from 'history';
import { z } from 'zod';

import {
  BankTransferInputAtSelectBeneficiaryStep,
  BankTransferInputAtSelectFromAccountStep,
  BankTransferInputAtSelectToAccountStep,
  externalTransferInputSchema,
  internalTransferInputSchema,
  PartialBankTransferInput,
} from '../contexts';
import { BankTransferFlowVariant } from '../Pages/CreateNewTransfer/types';
import routes from '../routes';

type BankTransferNavigationParams = {
  variant: BankTransferFlowVariant;
  bankTransfer: PartialBankTransferInput;
};

const bankTransferInputForToBeneficiaryVariantSchema =
  externalTransferInputSchema.pick({
    bankTransferRecipientId: true,
    transferType: true,
  });

type BankTransferInputForToBeneficiaryVariant = z.infer<
  typeof bankTransferInputForToBeneficiaryVariantSchema
>;

const bankTransferInputForCloseWalletVariantSchema =
  internalTransferInputSchema.pick({
    amount: true,
    fromBankAccountId: true,
    transferType: true,
  });

export type BankTransferInputForCloseWalletVariant = z.infer<
  typeof bankTransferInputForCloseWalletVariantSchema
>;

const bankTransferInputForCloseWalletToMainAccountVariantSchema =
  internalTransferInputSchema.pick({
    amount: true,
    fromBankAccountId: true,
    toBankAccountId: true,
    transferType: true,
  });

export type BankTransferInputForCloseWalletToMainAccountVariant = z.infer<
  typeof bankTransferInputForCloseWalletToMainAccountVariantSchema
>;

export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'default';
    bankTransfer: PartialBankTransferInput;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'toAccount';
    bankTransfer: BankTransferInputAtSelectFromAccountStep;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'closeWallet';
    bankTransfer: BankTransferInputForCloseWalletVariant;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'fromAccountToAccount';
    bankTransfer: BankTransferInputAtSelectToAccountStep;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'closeWalletToMainAccount';
    bankTransfer: BankTransferInputForCloseWalletToMainAccountVariant;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'toBeneficiary';
    bankTransfer: BankTransferInputForToBeneficiaryVariant;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params: {
    variant: 'fromAccountToBeneficiary';
    bankTransfer: BankTransferInputAtSelectBeneficiaryStep;
  },
): void;
export function navigateToBankTransfer(
  history: History,
  params?: BankTransferNavigationParams,
) {
  const { bankTransfer, variant } = params || {};

  history.push({
    pathname: routes.newTransfer,
    state: {
      ...bankTransfer,
      variant,
    },
  });
}
